<script lang="ts" setup>
const props = defineProps({
  label: {
    type: String,
    default: '',
  },
});

defineExpose({
  label: props.label,
});
</script>

<template>
  <div class="float-navigator-item min-h-1px">
    <slot></slot>
  </div>
</template>
